// extracted by mini-css-extract-plugin
export default {"cta":"XG-z","disabled":"YG-z"};